import { MetadataResponseDTO } from '@core/api/dtos/response/song/metadata'
import { Metadata } from '@core/api/entities/song/metadata'

export class MetadataMapper {
	static toEntity(data: MetadataResponseDTO): Metadata {
		return new Metadata({
			title: data.title,
			artist: data.artist,
			album: data.album,
			genre: data.genre,
			year: data.year,
			length: data.length,
			popularity: data.popularity,
			explicit: data.explicit,
			bpm: data.bpm,
			key: data.key,
			mode: data.mode,
		})
	}

	static toEntities(data: MetadataResponseDTO[]): Metadata[] {
		return data.map((item) => this.toEntity(item))
	}
}
